import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { SocialMediaSearch } from '../../model/social-media-search';
import { decodeFiwareString } from '../../shared/replacer-util';

export interface SocialMediaSearchState extends EntityState<SocialMediaSearch> { }

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'SocialMediaSearch' })
export class SocialMediaSearchStore extends EntityStore<SocialMediaSearchState> {

  constructor() {
    super();
  }
  akitaPreAddEntity(entity: SocialMediaSearch) {
    return decodeEntity(entity);
  }

  akitaPreUpdateEntity(_: SocialMediaSearch, newEntity: SocialMediaSearch) {
    return decodeEntity(newEntity);
  }
}

function decodeEntity(entity: SocialMediaSearch) {

  entity.searchPhrase = decodeFiwareString(entity.searchPhrase);
  entity.errorMessage = decodeFiwareString(entity.errorMessage);
  entity.name = decodeFiwareString(entity.name);
  return entity;
}
